import axios from "../../../util/axios";

export const updateGender = async ({ userId, gender }) => {
  if (!userId) throw new Error("userId is required");

  const payload = { gender };

  const { data } = await axios.post(`admin/v1/user/${userId}/update-gender`, payload);
  return data;
};
